var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"floatServiceBox",on:{"click":function($event){return _vm.goRouter()}}},[_c('div',{staticClass:"icon"}),_c('p',[_vm._v("在线客服")])])
}
var staticRenderFns = []

export { render, staticRenderFns }